import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle } = FiIcons;

const Capabilities = () => {
  const caps = [
    { title: 'Online Ordering', desc: 'Direct ordering that doesn\'t take a cut of every sale.' },
    { title: 'Push Notifications', desc: 'Send daily specials with one tap. Lands in their pocket, not spam.' },
    { title: 'Loyalty Programs', desc: 'Punch cards, points, tiers—whatever fits your workflow.' },
    { title: 'Reservations & Booking', desc: 'Simple booking flows for restaurants, salons, and service businesses.' },
    { title: 'Customer Apps', desc: 'Branded apps for your regulars.' },
    { title: 'POS Integration', desc: 'Sync orders and customers with your existing point-of-sale.' },
    { title: 'Custom Websites', desc: 'Menus, locations, hours, story—built once, easy to update.' }
  ];

  return (
    <section className="py-24 bg-[#07113a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-[#2a3658] border border-[#344271] rounded-[48px] p-10 md:p-20 overflow-hidden relative backdrop-blur-sm shadow-2xl">
          <div className="absolute top-0 right-0 w-1/2 h-full bg-[#3b82f6]/5 blur-[100px]"></div>
          
          <div className="relative z-10 grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-[#3b82f6] font-bold tracking-[0.2em] uppercase text-xs mb-4 block">Specialization</span>
              <h2 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight uppercase tracking-tight">
                Restaurants and retail, in particular.
              </h2>
              <p className="text-xl text-[#94a3b8] mb-8 leading-relaxed font-medium">
                We specialize in building the custom touchpoints that keep your customers coming back. No generic templates—just high-performance tools built for your specific operation.
              </p>
              <div className="p-6 bg-[#07113a]/50 rounded-2xl border border-[#344271] inline-block">
                <p className="text-white font-black uppercase tracking-widest text-sm italic">
                  Marketing tools that ship with the app—not bolted on.
                </p>
              </div>
            </div>
            
            <div className="grid gap-4">
              {caps.map((cap, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="flex items-start space-x-4 bg-[#07113a]/30 p-5 rounded-2xl border border-[#344271] hover:border-[#3b82f6]/30 transition-all group"
                >
                  <div className="mt-1">
                    <SafeIcon icon={FiCheckCircle} className="text-[#3b82f6] text-xl" />
                  </div>
                  <div>
                    <h4 className="text-white font-black uppercase tracking-tight text-sm mb-1">{cap.title}</h4>
                    <p className="text-[#94a3b8] text-xs font-medium">{cap.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Capabilities;